import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'
import ResetPasswordErrorScreen from '../screens/ResetPasswordErrorScreen'
import { ensureUniversalLoginContext } from '@/utils/helpers/universalLoginContext.ts'

async function bootstrap() {
  await ensureUniversalLoginContext('reset-password-error')
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ResetPasswordErrorScreen />
    </StrictMode>,
  )
}

bootstrap()
